export default "__VITE_ASSET__Br1XqeTq__"